<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div id="irrmap" style="height: 400px">
  </div>
</template>

<script>
    export default {
      props: {
        irr: Object,
        resources: Array,
        numResourcesToDisplay: Number
      },
      data() {
        return {
          map: false,
          numResourcesToDisplay_adjusted: 0,
        }
      },
      created() {
        this.numResourcesToDisplay_adjusted = Math.min(this.numResourcesToDisplay, this.resources.length);
      },
      mounted: function () {
        this.$nextTick(function () {  //don't run until the entire view has been rendered
          //init the map at the IRR's location, or default to US if coordinates are invalid
          var lat = (this.irr && this.irr.latitude) ? this.irr.latitude : 39.8;
          var lng = (this.irr && this.irr.longitude) ? this.irr.longitude : -98.6;
          var zoom = (this.irr && this.irr.latitude) ? 16 : 4;
          this.map = window.L.map('irrmap').setView([lat, lng], zoom);
          //this.map.dragging.disable(); //disable panning

          //add the content
          //L.tileLayer('/map/tile/{s}/{id}/{z}/{x}/{y}', {  //for use when proxying the tile requests

          /* DEPRECATED L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank">CC-BY-SA</a>',
      			maxZoom: 18,
            minZoom: 3,
      			id: 'mapbox.streets',
      			accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
      		}).addTo(this.map); */

          L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
            tileSize: 512,
            maxZoom: 18,
            minZoom: 3,
            zoomOffset: -1,
            id: 'jdonnell/ckg9vp1o403lx1as8i81og3ir',
            accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
          }).addTo(this.map);

          window.L.control.scale().addTo(this.map);

          //draw a circle for the IRR's area of coverage (only if valid coordinates)
          if(this.irr && this.irr.latitude && this.irr.longitude) {
      		var areaOfAuthority = L.circle([lat, lng], {
      			color: 'green',
      			fillColor: '#0f3',
      			fillOpacity: 0.1,
      			radius: this.irr.radius
      		}).addTo(this.map);
          }

          //add markers
          if(this.numResourcesToDisplay_adjusted) {
            for(var i=0; i<this.numResourcesToDisplay_adjusted; i++) {
              //add a marker with a popup bound to it
          		var resourcePopup = '<h4>' + this.resources[i].name + '</h4><p class="lead">' + this.resources[i].description + '</p><center><a type="button" class="btn btn-resource btn-sm" href="' + this.createResourceURL(this.resources[i].id) + '">View Resource</a></center>';
          		var resource = L.marker([this.resources[i].latitude, this.resources[i].longitude]).addTo(this.map);
          		resource.bindPopup(resourcePopup);
            }
          }

          //this.map.dragging.disable();
        })
      },
      methods: {
        createResourceURL: function(resourceID) {
          return '/resource/' + resourceID;
        }
      }
    }
</script>
